import { useMemo } from 'react';
import cx from 'classnames';
import { PlanCategoryEnum, tariffDisplayData } from '@/config';
import { SwitchButton } from '@/components';
import { switchButtonLightStyles } from '@/components/SwitchButton/SwitchButton.constant';

import styles from './TariffsTabs.module.sass';

const initTheme = {
  ...switchButtonLightStyles,
  width: '100%',
  height: '3.4rem',
  heightSlider: '3rem',
  background: '#F1F3F6',
  backgroundHover: '#F1F3F6',
  color: '#000',
  colorHover: '#131313',
  colorActive: '#ffffff',
  colorActiveHover: '#131313',
  backgroundSlider: '#0188FD',
  borderRadius: '1rem',
};

const possibleOptions = [
  {
    label: tariffDisplayData[PlanCategoryEnum.LITE].title,
    value: tariffDisplayData[PlanCategoryEnum.LITE].slug,
  },
  {
    label: tariffDisplayData[PlanCategoryEnum.PRO].title,
    value: tariffDisplayData[PlanCategoryEnum.PRO].slug,
  },
  {
    label: tariffDisplayData[PlanCategoryEnum.PRO_PLUS].title,
    value: tariffDisplayData[PlanCategoryEnum.PRO_PLUS].slug,
  },
];

interface TariffsTabsProps {
  value: PlanCategoryEnum;
  className?: string;
  onChange: (value: PlanCategoryEnum) => void;
  categories: PlanCategoryEnum[];
}

export const TariffsTabs = (props: TariffsTabsProps) => {
  const { value, className, onChange, categories } = props;

  const filteredOptions = useMemo(() => {
    return possibleOptions.filter((option) => {
      return categories.includes(option.value);
    });
  }, [categories]);

  const theme = useMemo(() => {
    return {
      ...initTheme,
      widthItem: `${100 / filteredOptions.length}%`,
      backgroundSlider: tariffDisplayData[value].color,
      color: tariffDisplayData[value].color,
    };
  }, [value, filteredOptions]);

  const handleChange = (val: string) => {
    onChange(val as PlanCategoryEnum);
  };

  const classes = cx(styles.tabs, className);

  return (
    <SwitchButton
      currentValue={value}
      theme={theme}
      options={filteredOptions}
      className={classes}
      onChange={handleChange}
    />
  );
};
